import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinhyderabad() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Hyderabad',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Hyderabad',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Hyderabad, catering to the transportation needs of IT parks, corporate offices, business centers, and industrial hubs across the city. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and timely travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Hyderabad.',

    top: 'Top Places to Visit in Hyderabad with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar is Hyderabad’s most iconic landmark, built in 1591 by Sultan Muhammad Quli Qutb Shah. This grand square-shaped monument features four towering minarets and intricate Islamic architecture. Surrounded by bustling bazaars, street food vendors, and shops selling pearls, bangles, and traditional crafts, Charminar is a cultural and historical hub, attracting tourists from across India and the world."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic fortress located on the outskirts of Hyderabad, known for its massive walls, impressive gateways, and acoustic marvels. Once the capital of the Qutb Shahi dynasty, it offers panoramic views of the city and nearby hills. The evening light and sound show narrates the fort’s rich history, making it a favorite destination for history enthusiasts and photographers."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar Lake is a large man-made lake in the heart of Hyderabad, famous for the gigantic Buddha statue standing on Gibraltar Rock in the middle of the water. The lake is popular for boating, evening walks, and lakeside leisure. Surrounded by parks, eateries, and promenades, it serves as a serene escape and recreational spot for locals and tourists."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest museums, housing an extensive collection of art, sculptures, manuscripts, and artifacts from India and around the world. Visitors can explore centuries of history and culture through exhibits such as Mughal miniatures, European paintings, and decorative arts. The museum provides an immersive educational experience for art and history enthusiasts."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City is one of the world’s largest film studio complexes and a popular entertainment destination near Hyderabad. Spread across thousands of acres, it features film sets, amusement rides, gardens, and live shows. Visitors can enjoy guided tours, interactive experiences, and cultural performances, making it a top choice for family outings and film enthusiasts."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace is a stunning 18th-century palace that once served as the seat of the Nizams of Hyderabad. The complex features grand halls, intricate interiors, beautiful courtyards, and royal artifacts. Visitors can explore the opulent architecture and learn about the history and lifestyle of the Nizams, making it a cultural and historical gem of the city."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a magnificent white marble temple dedicated to Lord Venkateswara, located on a hill overlooking Hyderabad. The temple offers panoramic views of the city and the lake below. Visitors can admire the detailed carvings, serene surroundings, and participate in spiritual rituals, making it a peaceful retreat in the heart of the city."
  },
  {
    "title": "Laad Bazaar",
    "description": "Laad Bazaar, located near Charminar, is Hyderabad’s famous shopping street, known for its vibrant bangles, jewelry, pearls, textiles, and handicrafts. The bustling markets and colorful storefronts create an authentic local experience. It is a must-visit for tourists looking to shop, explore, and enjoy the vibrant culture of the old city."
  },
  {
    "title": "Necklace Road",
    "description": "Necklace Road is a scenic boulevard along Hussain Sagar Lake, popular for evening walks, recreational activities, and lakeside dining. It features landscaped gardens, jogging tracks, and food stalls. The area is ideal for leisure, family outings, and enjoying the illuminated view of the Buddha statue on the lake."
  },
  {
    "title": "Qutb Shahi Tombs",
    "description": "The Qutb Shahi Tombs are the royal necropolis of the Qutb Shahi dynasty, located near Golconda Fort. The complex features grand domed tombs, landscaped gardens, and intricate stonework. Visitors can explore the historical architecture, learn about the dynasty’s legacy, and enjoy peaceful walks amidst the ancient structures."
  }
],


"services": [
{
"name": "Hyderabad Corporate Cabs",
"description": "Hyderabad Corporate Cabs provides end-to-end mobility solutions for IT parks, corporate offices, business hubs, and industrial zones across Hyderabad. With a managed fleet of sedans, SUVs, and shuttles, the service ensures punctual pickups, optimized routing, multi-shift support, GPS tracking, and professional chauffeurs. Ideal for enterprises of all sizes, it delivers reliable, safe, and efficient daily employee commute and executive transportation."
},
{
"name": "Business Taxi Hyderabad",
"description": "Business Taxi Hyderabad offers premium travel services for corporate meetings, airport transfers, client visits, and inter-office mobility. Featuring modern sedans and SUVs operated by trained chauffeurs, the service ensures punctuality, comfort, and professional etiquette. It is tailored for executives and business travelers seeking seamless mobility across Hyderabad’s corporate corridors."
},
{
"name": "Staff Shuttle Hyderabad",
"description": "Staff Shuttle Hyderabad provides high-capacity shuttle services with AC minibuses and vans designed for large employee groups. The service includes route optimization, automated attendance mapping, real-time GPS tracking, and strict safety protocols. Ideal for IT parks and large corporations, it ensures smooth, dependable, and coordinated workforce movement throughout the day."
},
{
"name": "Employee Transport Hyderabad",
"description": "Employee Transport Hyderabad delivers structured office commute services with fixed routes, shift-based scheduling, trained drivers, and digital systems for real-time trip monitoring. Suitable for IT companies, business parks, and manufacturing units, it ensures consistent, safe, and on-time employee travel across all major locations in Hyderabad."
},
{
"name": "Monthly Cab Hyderabad",
"description": "Monthly Cab Hyderabad offers contract-based transportation with dedicated vehicles, assigned chauffeurs, maintenance support, and centralized fleet management. Ideal for organizations requiring uninterrupted daily commute operations, it ensures predictable costs, reliable availability, and custom commuting plans tailored to workforce needs."
},
{
"name": "Best Corporate Cab Hyderabad",
"description": "Best Corporate Cab Hyderabad provides premium-grade mobility solutions featuring top-quality vehicles, expert chauffeurs, and superior safety standards. Suitable for executive travel, VIP guests, and business events, it offers refined comfort, strict punctuality, and a high-end travel experience across Hyderabad’s corporate hubs."
},
{
"name": "Affordable Office Cab Hyderabad",
"description": "Affordable Office Cab Hyderabad offers economical yet dependable transport solutions for SMEs, startups, and growing enterprises. With optimized routing, clean vehicles, professional drivers, and transparent pricing, it provides a budget-friendly option without compromising on safety, comfort, or reliability for daily employee commute."
},
{
"name": "Outstation Cab Hyderabad",
"description": "Outstation Cab Hyderabad delivers long-distance travel services for intercity meetings, business tours, factory visits, and executive road trips. With well-maintained sedans and SUVs, experienced drivers, interstate permits, and GPS tracking, it ensures comfortable, safe, and hassle-free outstation travel for corporate clients."
},
{
"name": "Sedan Cab Hyderabad",
"description": "Sedan Cab Hyderabad offers well-maintained executive sedans ideal for airport transfers, managerial commute, business visits, and premium travel needs. The service provides smooth rides, professional chauffeurs, and modern safety features, making it ideal for organizations seeking comfortable daily transportation for senior staff."
},
{
"name": "SUV Cab Hyderabad",
"description": "SUV Cab Hyderabad provides spacious, high-comfort SUVs suitable for team travel, senior executive movement, outstation business trips, and long city commutes. Backed by trained chauffeurs and safety monitoring, it ensures a premium and secure travel experience tailored to corporate requirements."
},
{
"name": "Company Fleet Hyderabad",
"description": "Company Fleet Hyderabad offers complete fleet outsourcing services including sedans, SUVs, shuttles, and employee cabs. This fully managed solution covers driver deployment, vehicle maintenance, scheduling, GPS monitoring, and compliance handling, helping companies streamline transport operations with ease and efficiency."
},
{
"name": "IT Park Commute Hyderabad",
"description": "IT Park Commute Hyderabad provides smart, tech-enabled mobility for employees working in major tech hubs such as HITEC City, Gachibowli, Financial District, and Madhapur. It includes multi-shift support, optimized routing, GPS tracking, and seamless fleet coordination designed to meet the fast-paced mobility demands of IT professionals."
},
{
"name": "Corporate Shuttle Hyderabad",
"description": "Corporate Shuttle Hyderabad offers large-scale shuttle operations for IT parks, corporate campuses, and SEZs. With AC minibuses, real-time tracking, automated boarding systems, and multi-route plans, it supports smooth and reliable bulk employee movement, ensuring punctuality and operational efficiency."
},
{
"name": "Office Pickup Drop Hyderabad",
"description": "Office Pickup Drop Hyderabad provides structured, fixed-route employee commute with professional drivers, real-time monitoring, and precise shift-aligned scheduling. Ideal for companies managing regular workforce travel, it ensures safe, predictable, and well-coordinated daily mobility for employees across Hyderabad."
},
{
"name": "Chauffeur Service Hyderabad",
"description": "Chauffeur Service Hyderabad delivers premium chauffeur-driven vehicles for executives, VIP guests, and business travelers. Offering well-trained drivers, luxury vehicles, flexible scheduling, and on-demand availability, it ensures a comfortable, discreet, and highly professional travel experience across the city."
}
],

"tableData": [
["Hyderabad Corporate Cabs", "Business Taxi Hyderabad"],
["Staff Shuttle Hyderabad", "Employee Transport Hyderabad"],
["Monthly Cab Hyderabad", "Best Corporate Cab Hyderabad"],
["Affordable Office Cab Hyderabad", "Outstation Cab Hyderabad"],
["Sedan Cab Hyderabad", "SUV Cab Hyderabad"],
["Company Fleet Hyderabad", "IT Park Commute Hyderabad"],
["Corporate Shuttle Hyderabad", "Office Pickup Drop Hyderabad"],
["Chauffeur Service Hyderabad", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Hyderabad",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable corporate cab services in Hyderabad, ensuring smooth and efficient transportation for employees and business executives across the city."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs throughout Hyderabad’s IT corridors, business districts, and industrial hubs, helping employees reach work and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our experienced chauffeurs provide safe, courteous, and disciplined rides, ensuring a secure and comfortable commute for corporate passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Select from sedans, SUVs, tempo travellers, and buses—each sanitized, serviced, and maintained for reliable and comfortable corporate travel in Hyderabad."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We provide flexible and tailored corporate cab rental plans designed to meet the specific commuting needs of employees and companies in Hyderabad."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team offers round-the-clock support for bookings, emergencies, and travel adjustments, ensuring uninterrupted corporate transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles undergo regular sanitization and are equipped with modern safety features, offering a hygienic and secure travel experience for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate transportation becomes hassle-free with our streamlined booking system and dependable coordination, ensuring smooth travel management."
  }
]







































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Hyderabad?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and IT parks across Hyderabad.',
  },
  {
    question: 'What types of corporate transportation services are available in Hyderabad?',
    answer: 'We offer employee transportation, corporate pickups and drops, shuttle services, airport transfers, and complete fleet management for businesses.',
  },
  {
    question: 'Do you support daily employee commute services in Hyderabad?',
    answer: 'Yes, we provide daily commute solutions with punctual pickups, optimized routes, and multi-shift transportation support for corporate employees.',
  },
  {
    question: 'How can companies book corporate cab services in Hyderabad?',
    answer: 'Companies can book via our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Hyderabad?',
    answer: 'We provide hatchbacks, sedans, SUVs, Innova Crysta, tempo travellers, luxury cars, and electric cabs depending on corporate requirements.',
  },
  {
    question: 'Do you offer long-term cab contracts for Hyderabad companies?',
    answer: 'Yes, we offer monthly, quarterly, and annual corporate transportation contracts with transparent and flexible pricing.',
  },
  {
    question: 'Are your cabs equipped with GPS tracking and safety features?',
    answer: 'Yes, all vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs.',
  },
  {
    question: 'Do you support night shift transportation services in Hyderabad?',
    answer: 'Absolutely. We support night shifts, early morning shifts, rotational schedules, and 24×7 corporate operations.',
  },
  {
    question: 'What payment options do you provide for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and also offer consolidated corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Reddy',
    feedback: 'Outstanding corporate cab service in Hyderabad. Very professional drivers and always on time. Highly recommended.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Chowdary',
    feedback: 'Their employee transportation service is extremely reliable. Clean vehicles and smooth coordination every day.',
    rating: 5,
  },
];








































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Hyderabad",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-hyderabad.jpg", // replace with real image URL
  "description":
    "Pune Corporate Cars India Private Limited provides professional corporate cab services in Hyderabad, including staff shuttles, business taxis, employee transportation, office pickup & drop, monthly cab services, outstation travel, chauffeur-driven cars, and complete corporate fleet management for companies across Hyderabad.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-hyderabad"
  }
};







  return (
    <div>

<Helmet>
  <title>Corporate Cab Service in Hyderabad | Employee & Business Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Hyderabad including staff shuttles, business taxis, employee transportation, office pickup & drop, monthly cabs, outstation travel, and chauffeur-driven fleet solutions."
  />

  <meta
    name="keywords"
    content="Hyderabad Corporate Cabs, Business Taxi Hyderabad, Staff Shuttle Hyderabad, Employee Transport Hyderabad, Monthly Cab Hyderabad, Best Corporate Cab Hyderabad, Affordable Office Cab Hyderabad, Outstation Cab Hyderabad, Sedan Cab Hyderabad, SUV Cab Hyderabad, Company Fleet Hyderabad, IT Park Commute Hyderabad, Corporate Shuttle Hyderabad, Office Pickup Drop Hyderabad, Chauffeur Service Hyderabad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/76.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinhyderabad;